import axios from '@/utils/axios';

const uploadBrandProduct = (accountId, formData) => axios.post(`/products/files/brand/${accountId}`, formData);

export default {
  uploadBrandProduct,
};
